export default "__VITE_ASSET__3MpWHVDp__ 700w, __VITE_ASSET__c8Qj0TmE__ 500w";